// Login Page
import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    setIsLoading(true);
    
    try {
      await login(email, password);
      navigate('/dashboard');
    } catch (err) {
      setErrorMessage(err.response?.data?.detail || 'Identifiants incorrects');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#191D1E',
      fontFamily: 'var(--font-corps)',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Subtle geometric accent */}
      <div style={{
        position: 'absolute',
        top: '-20%',
        right: '-10%',
        width: '600px',
        height: '600px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(57,125,255,0.08) 0%, transparent 70%)',
        pointerEvents: 'none'
      }} />
      <div style={{
        position: 'absolute',
        bottom: '-15%',
        left: '-5%',
        width: '400px',
        height: '400px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(57,125,255,0.05) 0%, transparent 70%)',
        pointerEvents: 'none'
      }} />

      <div style={{
        background: '#FFFFFF',
        borderRadius: '16px',
        boxShadow: '0 24px 64px rgba(0, 0, 0, 0.2)',
        padding: '48px 40px',
        width: '100%',
        maxWidth: '420px',
        position: 'relative',
        animation: 'fadeInUp 0.5s ease-out'
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '36px' }}>
          <img 
            src={`${BACKEND_URL}/api/static/logos/pde-logo-horizontal.png`}
            alt="Place des Énergies"
            style={{ height: '40px', width: 'auto', marginBottom: '20px' }}
            onError={(e) => { e.target.style.display = 'none'; }}
          />
          <p style={{
            fontFamily: 'var(--font-corps)',
            fontSize: '0.9375rem',
            color: '#687175',
            margin: 0,
            fontWeight: '400'
          }}>
            Connectez-vous à votre espace
          </p>
        </div>

        {/* Error */}
        {errorMessage && (
          <div style={{
            background: '#FEF2F2',
            border: '1px solid #FECACA',
            borderRadius: '10px',
            padding: '12px 16px',
            marginBottom: '24px',
            color: '#DC2626',
            fontSize: '0.875rem',
            fontFamily: 'var(--font-corps)',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            animation: 'slideDown 0.3s ease-out'
          }}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="8" fill="#DC2626" opacity="0.15"/><path d="M8 4.5V9" stroke="#DC2626" strokeWidth="1.5" strokeLinecap="round"/><circle cx="8" cy="11.5" r="0.75" fill="#DC2626"/></svg>
            {errorMessage}
          </div>
        )}

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{
              display: 'block',
              fontSize: '0.8125rem',
              fontWeight: '500',
              color: '#3C4649',
              marginBottom: '8px',
              fontFamily: 'var(--font-corps)'
            }}>
              Adresse email
            </label>
            <input
              type="email"
              placeholder="nom@entreprise.fr"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="login-email-input"
              style={{
                width: '100%',
                padding: '12px 16px',
                fontSize: '0.9375rem',
                fontFamily: 'var(--font-corps)',
                border: '1.5px solid #E2E6EA',
                borderRadius: '10px',
                outline: 'none',
                transition: 'all 200ms ease',
                boxSizing: 'border-box',
                color: '#191D1E',
                background: '#FAFBFC'
              }}
              onFocus={(e) => {
                e.target.style.borderColor = '#397DFF';
                e.target.style.boxShadow = '0 0 0 3px rgba(57,125,255,0.1)';
                e.target.style.background = '#FFFFFF';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = '#E2E6EA';
                e.target.style.boxShadow = 'none';
                e.target.style.background = '#FAFBFC';
              }}
            />
          </div>

          <div style={{ marginBottom: '28px' }}>
            <label style={{
              display: 'block',
              fontSize: '0.8125rem',
              fontWeight: '500',
              color: '#3C4649',
              marginBottom: '8px',
              fontFamily: 'var(--font-corps)'
            }}>
              Mot de passe
            </label>
            <input
              type="password"
              placeholder="Votre mot de passe"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="login-password-input"
              style={{
                width: '100%',
                padding: '12px 16px',
                fontSize: '0.9375rem',
                fontFamily: 'var(--font-corps)',
                border: '1.5px solid #E2E6EA',
                borderRadius: '10px',
                outline: 'none',
                transition: 'all 200ms ease',
                boxSizing: 'border-box',
                color: '#191D1E',
                background: '#FAFBFC'
              }}
              onFocus={(e) => {
                e.target.style.borderColor = '#397DFF';
                e.target.style.boxShadow = '0 0 0 3px rgba(57,125,255,0.1)';
                e.target.style.background = '#FFFFFF';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = '#E2E6EA';
                e.target.style.boxShadow = 'none';
                e.target.style.background = '#FAFBFC';
              }}
            />
          </div>

          <button
            type="submit"
            disabled={isLoading}
            data-testid="login-form-submit-button"
            style={{
              width: '100%',
              padding: '13px',
              fontSize: '0.9375rem',
              fontWeight: '500',
              fontFamily: 'var(--font-corps)',
              color: '#FFFFFF',
              backgroundColor: isLoading ? '#7BABFF' : '#397DFF',
              border: 'none',
              borderRadius: '10px',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              transition: 'all 200ms ease',
              boxSizing: 'border-box',
              boxShadow: isLoading ? 'none' : '0 2px 8px rgba(57,125,255,0.25)',
              letterSpacing: '0.01em'
            }}
            onMouseEnter={(e) => {
              if (!isLoading) {
                e.target.style.backgroundColor = '#2B6AE6';
                e.target.style.boxShadow = '0 4px 16px rgba(57,125,255,0.35)';
                e.target.style.transform = 'translateY(-1px)';
              }
            }}
            onMouseLeave={(e) => {
              if (!isLoading) {
                e.target.style.backgroundColor = '#397DFF';
                e.target.style.boxShadow = '0 2px 8px rgba(57,125,255,0.25)';
                e.target.style.transform = 'translateY(0)';
              }
            }}
          >
            {isLoading ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>

        {/* Forgot Password */}
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <a
            href="/forgot-password"
            style={{
              fontSize: '0.8125rem',
              color: '#687175',
              textDecoration: 'none',
              fontFamily: 'var(--font-corps)',
              transition: 'color 200ms ease'
            }}
            onMouseEnter={(e) => e.target.style.color = '#397DFF'}
            onMouseLeave={(e) => e.target.style.color = '#687175'}
          >
            Mot de passe oublié ?
          </a>
        </div>

        {/* Footer */}
        <div style={{
          marginTop: '32px',
          paddingTop: '20px',
          borderTop: '1px solid #EEF0F3',
          textAlign: 'center',
          fontSize: '0.75rem',
          color: '#939BA0',
          fontFamily: 'var(--font-corps)'
        }}>
          Place des Énergies © {new Date().getFullYear()}
        </div>
      </div>
    </div>
  );
}
